module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!./member-payment-history.ts"));
	}, "forms/member-payment-history/member-payment-history");
}